// extracted by mini-css-extract-plugin
export default {"notesModal":"styles_notesModal__o311W","heading":"styles_heading__yDILW","empty":"styles_empty__A-Ssu","emptyModal":"styles_emptyModal__mZshm","message":"styles_message__y91Bz"};